import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,
  Link,
  Avatar
} from '@mui/material';

import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Helmet } from 'react-helmet-async';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheets from '../components/customComplete/customCompleteWorksheets';
 
import Iconify from '../components/iconify';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Scrollbar from '../components/scrollbar/Scrollbar';
import { Api, UploadFile } from '../webservices';
// import { useStaticPicker } from '@mui/x-date-pickers/internals';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { md: '50%', xs: '95%' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  border: '3px solid #3C6BA5',
  borderRadius: 3,
};

const style1 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { md: '50%', xs: '95%' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  border: '2px solid #3C6BA5',
  borderRadius: 3,
};

const styleSkill = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '85%', sm: '75%' },
  bgcolor: 'background.paper',
  border: '3px solid #3C6BA5',
  boxShadow: 24,
  p: 3,
  borderRadius: 3,
};

const Spam = () => {

  const [value, setValue] = useState('spamCandidates');
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState()
  const [tableCount, setTableCount] = useState('')
  const [pages, setPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  useEffect(() => {
    getSpam()
  }, [])

  const getSpam = async (page) => {
    setLoading("Loading...")
    setTableData([])
    setTableCount('')
    setPages('')
    const body = {
      "page": page || 1,
      "limit": "17"
    }
    const token = localStorage.getItem('token');
    Api(`database/getSpamData`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.status === 200) {
            // toast.success(response.data.message, +'!');
            setTableData(response.data.result);
            setTableCount(response.data.count)
            const totalPage = Math?.ceil(response.data?.count / 35)
            setPages(totalPage)
            setLoading('')
          }
          else {
            // toast.warn(response.data.message, +'!');
            setLoading('No data found')
          }

        } else {
          // toast.warn(response.data.message, +'!');
          setLoading('No data found')
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');

      });
  };

  const getSpamUser = async (page) => {
    setLoading("Loading...")
    setTableData([])
    setTableCount('')
    setPages('')
    const body = {
      "page": page || 1,
      "limit": "35"
    }
    const token = localStorage.getItem('token');
    Api(`database/getSpamUser`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.status === 200) {
            // toast.success(response.data.message, +'!');
            setTableData(response.data.result);
            setTableCount(response.data.count)
            const totalPage = Math?.ceil(response.data?.count / 35)
            setPages(totalPage)
            setLoading('')
          }
          else {
            // toast.warn(response.data.message, +'!');
            setLoading('No data found')
          }
        } else {
          // toast.warn(response.data.message, +'!');
          setLoading('No data found')
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };


  const getSpamReport = async (page) => {
    setLoading("Loading...")
    setTableData([])
    setTableCount('')
    setPages('')
    const body = {
      "page": page || 1,
      "limit": "35"
    }
    const token = localStorage.getItem('token');
    Api(`database/getReporterUser`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.status === 200) {
            // toast.success(response.data.message, +'!');
            setTableData(response.data.result);
            setTableCount(response.data.count)
            const totalPage = Math?.ceil(response.data?.count / 35)
            setPages(totalPage)
            setLoading('')
          }
          else {
            // toast.warn(response.data.message, +'!');
            setLoading('No data found')
          }
        } else {
          // toast.warn(response.data.message, +'!');
          setLoading('No data found')
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const getSpamBlocked = async (page) => {
    setLoading("Loading...")
    setTableData([])
    setTableCount('')
    setPages('')
    const body = {
      "page": page || 1,
      "limit": "35"
    }
    const token = localStorage.getItem('token');
    Api(`database/getBlockedUser`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.status === 200) {
            // toast.success(response.data.message, +'!');
            setTableData(response.data.result);
            setTableCount(response.data.count)
            const totalPage = Math?.ceil(response.data?.count / 35)
            setPages(totalPage)
            setLoading('')
          }
          else {
            // toast.warn(response.data.message, +'!');
            setLoading('No data found')
          }
        } else {
          // toast.warn(response.data.message, +'!');
          setLoading('No data found')
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const handleTab = (Tab) => {
    // console.log("tab", Tab)
    setValue(Tab);
    if (Tab === "spamCandidates") {
      getSpam()
    } else if (Tab === "spamUsers") {
      getSpamUser()
    } else if (Tab === "spamReporters") {
      getSpamReport()
    } else {
      getSpamBlocked()
    }
  };

  const funClick = () => {
    if (value === "spamCandidates") {
      getSpam()
    } else if (value === "spamUsers") {
      getSpamUser()
    } else {
      getSpamReport()
    }
  }

  const handlePage = (event, valuee) => {
    setPageNumber(valuee);
    // getSpam(value);
    if (value === "spamCandidates") {
      getSpam(valuee)
    } else if (value === "spamUsers") {
      getSpamUser(valuee)
    } else if (value === "spamReporters") {
      getSpamReport(valuee)
    } else {
      getSpamBlocked(valuee)
    }
    // console.log("value", valuee)
  };

  const [searchResult, setSearchResult] = React.useState();
  const [tableShow, setTableShow] = useState(false)

  const searchDataFun = (data) => {
    // console.log("data=========>>>>>>", data);
    setTableCount(data?.length)
    setTableShow(true);
    if (data?.noData === "noData") {
      setLoading("No data found");
      if (value === 'spamCandidates') {
        setTableData([]);
      } else {
        setTableData([]);
      }
    } else {
      setSearchResult(data?.length);
      if (value === 'spamCandidates') {
        setTableData(data);
      } else {
        setTableData(data);
      }
    }
  };

  const resetDataFun = () => {
    // openJobBench() 
    // setTableShow(false)
    setTableShow(false)

    if (value === 'spamCandidates') {
      // getBenchPlacement(value);
    } else {
      // getRecPlacement(value);
    }
  }

  return (
    <>
      {/* <Stack direction="row" alignItems="flex-end" justifyContent="space-between" > */}
      <ToastContainer />
      <Search
        searchData={searchDataFun} func={resetDataFun}
        resetSearch={() => setSearchResult('')}
      />

      <Typography variant="h5" color={'text.secondary'} sx={{ mt: -2 }}>
        Spam
      </Typography>
      {tableShow && (

        <Typography sx={{ float: "right", mt: 0.5 }} fontSize={"0.85rem"} color={'text.secondary'}>
          Total: {searchResult || "0"}
        </Typography>
      )}
      {/* </Stack> */}
      <Stack flexDirection={'row'} justifyContent={'space-between'} mb={1}>
        <Stack sx={{ flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center' }}>

          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center' },
              value === 'spamCandidates' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTab('spamCandidates')}
          >
            {/* <Iconify
                 icon="subway:world"
                 fontSize={13}
                 color={valuee === 'company' ? '#CB4335' : 'text.textG'}
               /> */}
            <Typography variant="tabs" color={value === 'spamCandidates' ? 'text.secondary' : 'text.textG'} >
              Spam Candidates
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 0.5, alignItems: 'center' },
              value === 'spamUsers' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTab('spamUsers')}
          >
            {/* <Iconify
                 icon="subway:world"
                 fontSize={13}
                 color={valuee === 'user' ? '#CB4335' : 'text.textG'}
               /> */}
            <Typography variant="tabs" color={value === 'spamUsers' ? 'text.secondary' : 'text.textG'} >
              Spam Users
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 0.5, alignItems: 'center' },
              value === 'spamReporters' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTab('spamReporters')}
          >
            {/* <Iconify
                 icon="subway:world"
                 fontSize={13}
                 color={valuee === 'user' ? '#CB4335' : 'text.textG'}
               /> */}
            <Typography variant="tabs" color={value === 'spamReporters' ? 'text.secondary' : 'text.textG'} >
              Spam Reporters
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 0.5, alignItems: 'center' },
              value === 'blockedUsers' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTab('blockedUsers')}
          >
            {/* <Iconify
                 icon="subway:world"
                 fontSize={13}
                 color={valuee === 'user' ? '#CB4335' : 'text.textG'}
               /> */}
            <Typography variant="tabs" color={value === 'blockedUsers' ? 'text.secondary' : 'text.textG'} >
              Blocked Users
            </Typography>
          </Stack>
        </Stack>

      </Stack>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'text.secondary' }}>
              {value === 'spamCandidates' ? (
                <>
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Date</TableCell>
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Detail</TableCell>
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Contact Details</TableCell>
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Skills</TableCell>
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Visa & Terms</TableCell>
                </>
              ) : (
                null
              )}
              {
                value === 'spamReporters' ? (
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Reported Details</TableCell>
                ) : value === 'blockedUsers' ? (
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>User Details</TableCell>
                ) : (
                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Spammer Details</TableCell>
                )
              }

              <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>
                {value !== 'spamUsers' && value !== 'spamReporters' && value !== 'blockedUsers' ? (
                  "Reported By"
                ) : null}
              </TableCell>

              <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {
              (Array.isArray(tableData) && tableData)?.map((row, index) => (

                <ManagementRow index={index} key={row?._id} data={row} fun={funClick}
                  loading={loading} value={value}

                />
              ))
            }
          </TableBody>
        </Table>

      </TableContainer>

      {tableCount > 35 ? (
        <Stack
          spacing={2}
          sx={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2
          }}
        >

          <Button
            variant="outlined"
            sx={{
              minWidth: 16, height: 32, borderRadius: '5px',
              mt: 2,
              ml: 0.5, cursor: 'pointer'
            }}
            onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
          >
            {"<"}
          </Button>

          <Pagination
            variant="outlined"
            shape="rounded"
            color="secondary"
            hideNextButton
            hidePrevButton
            count={pages}
            page={pageNumber}
            onChange={handlePage}
            sx={{ cursor: 'pointer', mb: (pageNumber !== 1) ? -4 : -2 }}
          />

          <Button
            variant="outlined"
            sx={{
              minWidth: 16, height: 32, borderRadius: '5px', mr: 1,
              mt: -2,
              cursor: 'pointer'
            }}
            onClick={() => setPageNumber(prev => Math.min(prev + 1, pages))}
          >
            {">"}
          </Button>

        </Stack>

      ) : null}

      {loading !== "" && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
        </Stack>
      )}
    </>
  )
}

export default Spam;

function ManagementRow({ data, fun, value, index }) {

  const [phoneCopy, setPhoneCopy] = useState(false);
  const [emailCopy, setEmailCopy] = useState(false);

  const navigate = useNavigate();

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const tablebg = 'rgba(17, 32, 49, 0.08)';

  const styleClients11 = {
    height: "90%",
    position: 'absolute',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '45%', sm: '65%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleSkillset11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '50%', sm: '70%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    // paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  const [openRes, setOpenRes] = useState('');
  const [openR, setOpenR] = useState(false);

  const openResume = (resUrl) => {
    setOpenRes(resUrl)
    setOpenR(true);
  };
  const closeResume = () => {
    setOpenR(false);
  };

  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);

  const [opensRea, setOpensRea] = useState(false);
  const [spamReas, setSpamReas] = useState('')
  const handleOpensRea = (reas) => {
    setSpamReas(reas)
    setOpensRea(true);
  } 
  const handleClosesRea = () => setOpensRea(false); 

  const styless = {
    position: 'absolute',
    top: '48%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '95%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    border: '3px solid #3C6BA5',
    borderRadius: 3,
  };

  const [reason, setReason] = useState()
  const [note, setNote] = useState()

  const [openActive, setOpenActive] = useState(false);
  const handleOpenActive = () => setOpenActive(true);
  const handleCloseActive = () => setOpenActive(false);

  const [openSpam, setOpenSpam] = useState(false);
  const handleOpenSpam = () => setOpenSpam(true);
  const handleCloseSpam = () => setOpenSpam(false);

  const [openSpamRep, setOpenSpamRep] = useState(false);
  const handleOpenSpamRep = () => setOpenSpamRep(true);
  const handleCloseSpamRep = () => setOpenSpamRep(false);

  const [newSkill, setNewSkill] = useState([])

  const notSpam = (id) => {
    const body = {
      "database_id": id,
    }
    const token = localStorage.getItem('token');
    Api('database/notSpamDataCondidate', 'POST', body, token).then((Response) => {
      // console.log("Response", Response)
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          // if (value === 'spamCandidates') {
          //   fun();
          // } else if (value === 'spamUsers') {
          //   fun();
          // } else if (value === 'spamReporters') {
          //   fun();
          // } else {
          //   fun();
          // }
          fun()
          handleCloseSpam()
          toast.success(Response.data?.resmessage)
          // console.log("Response.data?.resmessage", Response.data?.resmessage)
        }
      } else {
        toast.error(Response.data?.resmessage)
        handleCloseSpam()
       
      }
      
    })
  }

  const notSpamReport = (id) => {
    const body = {
      "database_id": id,
    }
    const token = localStorage.getItem('token');
    Api('database/reportSpamDataCondidate', 'POST', body, token).then((Response) => {
      // console.log("Response", Response)
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          // if (value === 'spamCandidates') {
          //   fun();
          // } else if (value === 'spamUsers') {
          //   fun();
          // } else if (value === 'spamReporters') {
          //   fun();
          // } else {
          //   fun();
          // }
          fun()
          handleCloseSpamRep()
          toast.success(Response.data?.resmessage)
          // console.log("Response.data?.resmessage", Response.data?.resmessage)
        }
      } else {
        toast.error(Response.data?.resmessage)
        handleCloseSpamRep()
       
      }
      
    })
  }

  const statusChange = (data) => {
    if(!reason){
      toast.warn("Please enter reason first")
      return
    }

    let sts = '';
    if (data.status === 'active') {
      sts = 'inactive';
    } else {
      sts = 'active';
    }
    const token = localStorage.getItem('token');
    const body = {
      "user_id": data?._id,
      "reason": reason,
      "rejectNote": note,
      "status": sts
    }
    Api(`database/activeInactiveUser`, 'POST', body, token).then((Response) => {
      // console.log('======response=====>', Response);
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          toast.success(Response.data.message);
          fun()
          handleCloseActive()
          setNote('')
          setReason('')
          // console.log('======data====>', Response.data.data);
        } else {
          // console.log('===========>', +Response);
          handleCloseActive()
          toast.error(Response.data.message);
        }
      }
     else {
      // console.log('===========>', +Response);
      handleCloseActive()
      toast.error(Response.data.message);
    }
    });
  }

  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const confirmCloseDelete = () => setOpenConfirmDelete(false);
  const confirmOpenDelete = () => setOpenConfirmDelete(true);

  const [openConfirmDelete1, setOpenConfirmDelete1] = useState(false);
  const confirmCloseDelete1 = () => setOpenConfirmDelete1(false);
  const confirmOpenDelete1 = () => setOpenConfirmDelete1(true);

  const undoAllSpam = (emailId) => {
    const token = localStorage.getItem('token');
    const body = {
      // "user_id": id,
       "userEmail":emailId
    }
    Api(`database/undoAllSpam`, 'POST', body, token).then((Response) => {
      // console.log('======response=====>', Response);
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.resmessage);
          fun()
          confirmCloseDelete()
          // console.log('======data====>', Response.data.data);
        } else {
          // console.log('===========>', +Response);
          confirmCloseDelete()
          toast.error(Response.data.resmessage);
        }
      } else {

        confirmCloseDelete()
        toast.error(Response.data.error);
        toast.error(Response.data.resmessage);
      }
    });
  }

  const markedAllSpam = (id) => {
    const token = localStorage.getItem('token');
    const body = {
      "user_id": id,
    }
    Api(`database/markAllDataSpam`, 'POST', body, token).then((Response) => {
      // console.log('======response=====>', Response);
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.resmessage);
          fun()
          confirmCloseDelete1()
          // console.log('======data====>', Response.data.data);
        } else {
          // console.log('===========>', +Response);
          confirmCloseDelete1()
          toast.error(Response.data.resmessage);
        }
      } else {

        confirmCloseDelete1()
            toast.error(Response.data.error);
            toast.error(Response.data.resmessage);
      }
    });
  }

  return (
    <>

      <TableRow key={data?._id} sx={{
        background: index % 2 === 0 ? 'text.background' : tablebg,
        '&:last-child td, &:last-child th': { border: 0 },
        '&:hover': { boxShadow: 5 },
      }}>
        {value === "spamCandidates" ? (
          <>
            <TableCell sx={{ paddingTop: 1, paddingBottom: 1, paddingRight: 2.5 }}>

              <Typography sx={{ color: 'text.secondary', ml: 4.1 }} >

                Up - {`${new Date(data?.benchAppId?.updatedAt || data?.recruitorAppId?.updatedAt)?.toLocaleString('en-US', optionsDate)} 
                ${String(new Date(data?.benchAppId?.updatedAt || data?.recruitorAppId?.updatedAt)?.getHours())?.padStart(2, '0')}`}:{`${String(new Date(data?.benchAppId?.updatedAt || data?.recruitorAppId?.updatedAt)?.getMinutes())?.padStart(2, '0')}`}

              </Typography>
              <FormControlLabel
                sx={{ ml: -1, mt: -2.5, mb: -2 }}
                control={
                  <Checkbox
                  // checked={checked1 || false}
                  // onClick={selectCheckBox}
                  />
                }

              />

              <Typography sx={{ ml: 4.1 }} >
                Cr - {`${new Date(data?.benchAppId?.createdAt || data?.recruitorAppId?.createdAt)?.toLocaleString('en-US', optionsDate)} 
                ${String(new Date(data?.benchAppId?.createdAt || data?.recruitorAppId?.createdAt)?.getHours())?.padStart(2, '0')}`}:{`${String(new Date(data?.benchAppId?.createdAt || data?.recruitorAppId?.createdAt)?.getMinutes())?.padStart(2, '0')}`}

              </Typography>

            </TableCell>

            <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 170 }}>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',

                }}
              >
                <Typography
                  sx={{
                    color: 'text.secondary',
                    fontWeight: '600',
                    fontSize: '0.9rem',
                    maxWidth: 180,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    navigate('/resumeDetail', {
                      state: {
                        // addedSkills,
                        data,
                        mtab: 'Resume',
                        // fTab,
                      },
                    });
                  }}
                >
                  {data?.benchAppId?.fullName || data?.recruitorAppId?.fullName || '-'}
                </Typography>

                <Iconify
                  icon="devicon:linkedin"
                  color={'text.textG'}
                  sx={{
                    ml: 1,
                    height: 17,
                    width: 17,
                    cursor: 'pointer',
                    mb: -0.5,
                  }}
                  hover
                  onClick={() =>
                    window.open(data?.benchAppId?.linkedinUrl || data?.recruitorAppId?.linkedinUrl, '_blank')
                  }
                />

                <Iconify
                  icon="cuida:document-text-outline"
                  color="#1E74B3"
                  sx={{
                    ml: 0.6,
                    height: 18,
                    width: 18,
                    mb: -0.4,
                    cursor: 'pointer',
                  }}
                  hover
                  onClick={() =>
                    openResume(data?.benchAppId?.resumeUrl || data?.recruitorAppId?.resumeUrl)
                  }
                />
              </Box>

              <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {data?.benchAppId?.currentCompany || data?.recruitorAppId?.currentCompany || "-"}
              </Typography>
              <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {data?.benchAppId?.jobTitle || data?.recruitorAppId?.jobTitle || "-"}
              </Typography>
            </TableCell>

            <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 170 }}>
              <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {data?.benchAppId?.phone || data?.recruitorAppId?.phone || "-"}
              </Typography>
              <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {data?.benchAppId?.email || data?.recruitorAppId?.email || "-"}
              </Typography>
              <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <Typography >
                  {
                    (data?.benchAppId?.cityOrZipcode || data?.benchAppId?.stateCode)
                      ? `${data?.benchAppId?.cityOrZipcode}, ${data?.benchAppId?.stateCode}`
                      : (data?.recruitorAppId?.city || data?.recruitorAppId?.stateCode
                        ? `${data?.recruitorAppId?.city}, ${data?.recruitorAppId?.stateCode || '-'}`
                        : "-"
                      )
                  }

                </Typography>
                {data?.relocation === 'yes' ? (
                  <Iconify icon="mdi:aeroplane" fontSize={19} color={'text.secondary'} />
                ) : ''}
              </Stack>

            </TableCell>

            <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 175, paddingRight: 2 }}>
              {data?.benchAppId?.skill?.length > 0 || data?.recruitorAppId?.skill?.length > 0 ? (
                <Grid container sx={{ maxWidth: 160, height: 44, overflow: 'hidden', textOverflow: 'ellipsis', gap: 0.3 }}>
                  {(data?.benchAppId?.skill || data?.recruitorAppId?.skill)?.slice(0, 3)?.map((item, index, arr) => (
                    item && (
                      <Typography key={index} sx={{ display: 'inline' }}>
                        {item}
                        {index < arr.length - 1 && ' | '}
                      </Typography>
                    )
                  ))}
                </Grid>
              ) : (
                <Typography>-</Typography>
              )}

              <Typography
                sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => {
                  handleOpens();
                  setNewSkill(data?.benchAppId?.skill || data?.recruitorAppId?.skill);
                }}
              >
                view all
              </Typography>
              {/* <Typography>-</Typography> */}
            </TableCell>

            <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 130 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                <Typography>
                  {data?.benchAppId?.visaType || data?.recruitorAppId?.visaType || "-"}
                </Typography>
                {data?.benchAppId?.visaTransfer === "yes" || data?.recruitorAppId?.visaTransfer === "yes" ? (
                  <Iconify icon="fluent:arrow-swap-16-filled" width="1.1rem" />
                ) : ""}
              </Box>

              <Typography>
                {data?.benchAppId?.expectedCompensation || data?.recruitorAppId?.expectedCompensation ? (
                  <>
                    ${data?.benchAppId?.expectedCompensation || data?.recruitorAppId?.expectedCompensation}
                    {(data?.benchAppId?.chargeType === 'hourly' || data?.recruitorAppId?.chargeType === 'hourly') ? '/Hour' : 'K'}
                  </>
                ) : "-"}
              </Typography>

              <Typography sx={{ textTransform: "capitalize" }} color={'text.textG'}>
                {data?.benchAppId?.taxTerm || data?.recruitorAppId?.taxTerm || '-'}
              </Typography>
            </TableCell>

            <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 140 }}>
              <Typography>
                {data?.companyName || data?.companyName || "-"}
              </Typography>
              <Typography>
                {data?.name || data?.name || "-"}
              </Typography>
              <Typography>
                {data?.companyEmail || data?.companyEmail || "-"}
              </Typography>
            </TableCell>
            <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 140 }}>
              {/* <Typography sx={{}}>{data?.reportedName ? data?.reportedName : "-"}</Typography> */}
              <Typography sx={{}}>{data?.reportByName || data?.reportByName || "-"}</Typography>
              <Typography sx={{}}>{data?.reportByEmail || data?.reportByEmail || "-"}</Typography>
              <Typography sx={{color: "#3C6BA5", cursor: 'pointer'}} onClick={()=>handleOpensRea(data?.reportReason)}>Spam Reason</Typography>
              {/* <Typography sx={{}}>{data?.reportReason || data?.reportReason || "-"}</Typography> */}

            </TableCell>
            <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <Typography sx={{ cursor: 'pointer' }} onClick={() => handleOpenSpam()}>Not Spam</Typography>
              <Typography sx={{ cursor: 'pointer' }}  onClick={() => handleOpenSpamRep()}>Report Spam</Typography>
              <Typography sx={{}}>{"-"}</Typography>
            </TableCell>
          </>
        ) : value === 'spamUsers' ? (
          <>
            <TableCell sx={{}}>
              <Typography sx={{}}>{data?.companyName ? data?.companyName : "-"}</Typography>
              <Typography sx={{}}>{data?.contactPersonName ? data?.contactPersonName : "-"}</Typography>
              <Typography sx={{}}>{data?.email ? data?.email : "-"}</Typography>
            </TableCell>
            <TableCell sx={{}}>
              <Typography sx={{}}>No. of Spam Candidate Reported - {data?.spamCount}</Typography>
              <Typography sx={{}}>No. of Candidate Verified Spam - {data?.verifySpam}</Typography>
              <Typography sx={{}}>No. of Candidate Verified Not Spam - {data?.NotSpam}</Typography>
            </TableCell>
            <TableCell sx={{}}>
              <Typography sx={{}}>Pending Review - {data?.pendingReview}</Typography>
              <Typography sx={{ color: "red", cursor: "pointer" }} onClick={() => confirmOpenDelete1()}>Mark All Data Spam</Typography>
              <Typography sx={{ color: "red", cursor: "pointer" }} onClick={() => handleOpenActive()}>
                {data?.status === "inactive" ? "Inactive" : 'Active'}</Typography>
            </TableCell>
          </>
        ) : value === 'spamReporters' ? (
          <>
            <TableCell sx={{}}>
              <Typography sx={{}}>{data?.companyName ? data?.companyName : "-"}</Typography>
              <Typography sx={{}}>{data?.contactPersonName ? data?.contactPersonName : "-"}</Typography>
              <Typography sx={{}}>{data?.email ? data?.email : "-"}</Typography>
            </TableCell>
            <TableCell sx={{}}>
              <Typography sx={{}}>No. of Spam Candidate Reported - {data?.reportCount}</Typography>
              <Typography sx={{}}>No. of Candidate Verified Spam - {data?.verifySpam}</Typography>
              <Typography sx={{}}>No. of Candidate Verified Not Spam - {data?.NotSpam}</Typography>
            </TableCell>
            <TableCell sx={{}}>
              <Typography sx={{}}>Pending Review - {data?.pendingReview}</Typography>
              <Typography sx={{ color: "red", cursor: "pointer" }} onClick={() => handleOpenActive()}>
                {data?.status === "inactive" ? "Inactive" : 'Active'}
              </Typography>
              <Typography sx={{ color: "green", cursor: "pointer" }}
                onClick={() => confirmOpenDelete()}>Undo All Marked Spam</Typography>
            </TableCell>
          </>
        ) : (
          <>
            <TableCell sx={{}}>
              <Typography sx={{}}>{data?.companyName ? data?.companyName : "-"}</Typography>
              <Typography sx={{}}>{data?.contactPersonName ? data?.contactPersonName : "-"}</Typography>
              <Typography sx={{}}>{data?.email ? data?.email : "-"}</Typography>
            </TableCell>
            <TableCell sx={{}}>
              {/* <Typography sx={{}}>{data?.companyName ? data?.companyName : "-"}</Typography>
        <Typography sx={{}}>{data?.fullName ? data?.fullName : "-"}</Typography>
        <Typography sx={{}}>{data?.email ? data?.email : "-"}</Typography> */}
            </TableCell>
            <TableCell sx={{}}>
              <Typography sx={{}}>{data?.status === "inactive" ? "Inactive" : 'Active'}</Typography>
              <Typography >
              
              <span style={{ color: "#3C6BA5" }}>Note{":- "}</span>
                {data?.rejectNote}
                </Typography>
              <Typography >
              <span style={{ color: "#3C6BA5" }}>Reason{":- "}</span>
                {data?.rejectReason}
              </Typography>
            </TableCell>
          </>
        )} 
      </TableRow>


      <Modal open={openActive} onClose={handleCloseActive} style={{ borderRadius: 10 }}>
        <Box sx={[styless, { width: '20%' }]}>
          <Stack sx={{ justifyContent: "center", alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: "100%" }}>
              <TextField
                label="Reason"
                variant="outlined"
                // size="small"
                fullWidth
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: "100%", mt: 1.5 }}>
              <TextField
                label="Notes"
                variant="outlined"
                // size="small"
                fullWidth
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </Stack>
            <Stack sx={{
              flexDirection: 'row', justifyContent: 'space-between',
              width: '25%', mt: 3, alignSelf: 'center', gap: 3
            }}>
              <Button color="custom" sx={{}} variant="contained"
                onClick={() => statusChange(data)}
              >
                Submit
              </Button>
              <Button color="custom" sx={{}} variant="contained" onClick={handleCloseActive}>
                Close
              </Button>
            </Stack>
          </Stack>

        </Box>
      </Modal>

      <Modal open={openConfirmDelete} onClose={confirmCloseDelete} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: "center", alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: "100%" }}>
              <Typography sx={{}} variant='h6' textAlign={"center"} color={'red'}>
                Would you want to undo all marked spam?

              </Typography>
            </Stack>
            <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}>
              <Button color="custom" sx={{}} variant="contained" size='small'
                onClick={() => undoAllSpam(data?.email)}

              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size='small' onClick={confirmCloseDelete}>
                No
              </Button>
            </Stack>
          </Stack>

        </Box>
      </Modal>

      <Modal open={openConfirmDelete1} onClose={confirmCloseDelete1} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: "center", alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: "100%" }}>
              <Typography sx={{}} variant='h6' textAlign={"center"} color={'red'}>
                Would you want to all marked spam?

              </Typography>
            </Stack>
            <Stack sx={{
              flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3,
              alignSelf: 'center'
            }}>
              <Button color="custom" sx={{}} variant="contained" size='small'
                onClick={() => markedAllSpam(data?._id)}

              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size='small' onClick={confirmCloseDelete1}>
                No
              </Button>
            </Stack>
          </Stack>

        </Box>
      </Modal>

      <Modal open={openSpam} onClose={handleCloseSpam} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: "center", alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: "100%" }}>
              <Typography sx={{}} variant='h6' textAlign={"center"} color={'red'}>
                Would you want to not spam?

              </Typography>
            </Stack>
            <Stack sx={{
              flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3,
              alignSelf: 'center'
            }}>
              <Button color="custom" sx={{}} variant="contained" size='small'
                onClick={() => notSpam(data?._id)}

              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size='small' onClick={handleCloseSpam}>
                No
              </Button>
            </Stack>
          </Stack>

        </Box>
      </Modal>

      <Modal open={openSpamRep} onClose={handleCloseSpamRep} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: "center", alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: "100%" }}>
              <Typography sx={{}} variant='h6' textAlign={"center"} color={'red'}>
                Would you want to report spam?

              </Typography>
            </Stack>
            <Stack sx={{
              flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3,
              alignSelf: 'center'
            }}>
              <Button color="custom" sx={{}} variant="contained" size='small'
                onClick={() => notSpamReport(data?._id)}

              >
                Yes
              </Button>
              <Button color="custom" sx={{}} variant="contained" size='small' onClick={handleCloseSpamRep}>
                No
              </Button>
            </Stack>
          </Stack>

        </Box>
      </Modal>

      <Modal open={openR} onClose={closeResume} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients11]}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mt: -2.5 }}>
            <Typography variant="h6" sx={{
              textAlign: 'center', color: 'text.secondary', fontWeight: 'bold', flex: 1,
              mb: 1, mt: 1
            }}>
              Resume
            </Typography>
            <a href={openRes} download>
              <Iconify icon="mdi:download" width="1.3rem" color='text.secondary' />
            </a>
          </Box>
          <Scrollbar sx={{ height: "97%", Scrollbar: 'thin', border: '2px solid #3C6BA5', borderColor: 'text.secondary', borderRadius: 2 }}>
            {/* <Divider /> */}
            <Stack sx={{ p: 1.5 }}>
              <iframe title="resume" src={suru + openRes + lll} width="100%" height="700px" />
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={opens} onClose={handleCloses} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset11}>

          <Typography variant="h5" color={'#3C6BA5'} sx={{ ml: "46%" }}>
            Skills

          </Typography>

          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 0.5,


                flexWrap: 'wrap'
              }}
            >

              {newSkill?.filter(item => item !== '' && item != null)?.map((item, index) => (

                item && (
                  <Box
                    key={index}
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="text.textG"
                      textAlign="center"
                      textTransform="capitalize"
                      sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                    >
                      {item} {index < data?.skill?.length - 1 && '|'}

                    </Typography>
                  </Box>
                )
              ))}

            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={opensRea} onClose={handleClosesRea} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset11}>

          <Typography variant="h5" color={'#3C6BA5'} sx={{ ml: "46%" }}>
            Reason

          </Typography>

          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 0.5,

                flexWrap: 'wrap'
              }}
            >
              <Typography sx={{mt:1}}>

            {spamReas}
              </Typography>


            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

    </>
  );
}

function Search({ searchData, func, funcc, funnc, resetSearch }) {

  const [formValues, setFormValues] = useState({
    commonSearch: "",
  });

  const [loading, setLoading] = useState(false);

  const searchPlace = (page = 1) => {
    setLoading(true);

    const token = localStorage.getItem('token');
    const body = {
      "commonSearch": formValues.commonSearch,
      "page": page,
      "limit": "35"
    }
    Api('resume/searchPlacement', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 401) {
          setLoading(false);
          searchData(({ noData: "noData" }))
          // alert("fdf")
        }
        if (response.status === 200) {
          if (response.data.status === 200) {
            const totalPage = Math.ceil(response?.data?.count / 50)
            searchData(response.data?.data, response.data?.count, totalPage)

            setLoading(false);
            // console.log("response.data.data", response.data.data)
          } else {
            setLoading(false);
            // console.log('Error:', response.data.message);
            // searchData(({ noData: "noData" }))
          }

        }

      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const clearInputField = () => {
    resetSearch()
    setFormValues({
      ...formValues,
      commonSearch: '',
    });
  }

  return (

    <>
    <Helmet>
        <title> Spam | Foxearch </title>
      </Helmet>

      <div style={{ display: 'flex', alignItems: 'center', left: 115, right: 0 }}>
        <Paper
          component="form"
          sx={{
            // p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            width: '25%',
            border: '1px solid #1E74B3',
            borderRadius: '10px',
            marginTop: -18,
          }}
        >

          <InputBase
            sx={{ flex: 1, color: 'text.primary', border: 'none', outline: 'none', pl: 1 }}
            placeholder="Email"
            inputProps={{ 'aria-label': 'search' }}
            value={formValues.commonSearch}
            onChange={(e) => {
              setFormValues({ ...formValues, commonSearch: e.target.value });

            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                // searchPlace();

              }
            }}
          />
        </Paper>
        {/* <Button style={{ marginLeft: '16px', color: 'white', backgroundColor: '#1E74B3', borderRadius: '10px', marginTop: '4px', height: '41px', width: '130px' }} onClick={fn}>Search</Button> */}
        <Button color="custom" variant="contained" size="small" sx={{ ml: 1.6, mt: -18 }}
          // disabled={formValues1.commonSearch === ''}
          disabled={loading}
        // onClick={() => { searchPlace() }}
        >
          {/* Search */}
          {loading ? <CircularProgress size={24} /> : 'Search'}
        </Button>
        {(
          formValues?.commonSearch

        ) && (

            <Button color="custom" variant="contained" size="small" sx={{ ml: 1.6, mt: -18 }}
              onClick={() => { clearInputField(); func() }}>
              Close
            </Button>
          )}

      </div>

    </>
  );

}